<template>
  <div class="leftCardContainer">
    <div class="rightSideTitleActions">
      <span class="leftTitle"> {{$tc('CustomFields', 2)}}</span>
      <div class="actionsContainer">
        <div class="searchContainer">
          <v-icon> search </v-icon>
          <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
            borderRadius: '0px',
            width: '130px',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
          }" @input="handleSearch($event)" />
        </div>
        <CustomButton icon="delete" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="deleteDialogIsOpen=true" :disabled="!selectedCustomField"/>
        <CustomButton icon="download" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleDownload" :disabled="true"/>
        <CustomButton icon="add" :width="'20px'" :height="'20px'" :iconSize="12" :disabled="userIsCreatingOrEditingData"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleAdd" />
      </div>
    </div>
    <div class="tableDivContainer">
      <Table :checkbox="false" :loading="loading" :headers="headers" :items="customField" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="true"
      />
    </div>
    <dialog-choice :isOpen="deleteDialogIsOpen" :title="$t('DeleteCustomField')" :content="$t('DeleteCustomFieldConfirmation')"
      :mainActionLabel="$t('Confirm')" @mainAction="handleDelete" :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false" icon="mdi-delete" iconColor="var(--app-primary-base)" />
    <dialog-choice :isOpen="deleteDialogConfirmation" :title="$t('DeleteCustomField')" :content="$t('DeleteCustomFieldDialog')"
      :mainActionLabel="$t('Confirm')" @mainAction="handleDeleteForced" :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false;deleteDialogConfirmation=false;" icon="mdi-delete" iconColor="#FF0000" isDeleteDialog=true
      :extraContent="$t('UndoWarning')" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { customFieldsMixin } from "@/mixins/customFieldsMixin";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import CustomButton from "@/newComponents/_Atoms/CustomButton.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
import LoadingSpinner from "vue-loading-overlay";
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';

export default {
  name: "TableView",

  props:{

    selectedCustomField: {
      type: Object,
    },

  },

  components: {
    Table,
    ManagementPage,
    CustomButton,
    InputField,
    DialogContent,
    LoadingSpinner,
    DialogChoice,
  },

  mixins: [customFieldsMixin],

  data() {
    return {
      availableWebUsers: null,
      availableWebViewerUsers: null,
      availableMobileUsers: null,
      availableMobileViewerUsers: null,
      maxWebUsers: null,
      maxWebViewerUsers: null,
      maxMobileUsers: null,
      maxMobileViewerUsers: null,
      dialog: false,
      deleteDialogIsOpen: false,
      deleteDialogConfirmation: false,
      loadingUpload: false,
      activeTabDialog: 0,
      value: null,
      fileTypes: [".xlsx"],
      type: "normal",
      history: [],
      file: [],
      search: null,
      activeTab: 0,
      loading: false,
      userType: 'web',
      scrollTop: 0,
      sortOrder: null,
      scrollHeight: 0,
      selectedRows: [],
      pageNumber: 1,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      lastPage: 2,
      headers: [
        { text: this.$i18n.tc("Code", 1), varName: "code" },
        { text: this.$i18n.tc("Label", 1), varName: "label" },
        { text: this.$i18n.tc("Object", 1), varName: "object_type_name" },
        { text: this.$i18n.tc("Type", 1), varName: "input_type" },
      ],
      customField: [],
      customButtonStylesSecondary: {
        'marginRight': '10px',
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesMain: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesExtra: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      userIsCreatingOrEditingData: false,
    };
  },

  mounted() {
    this.getInitialCustomFields();
    bus.$on("reload-custom-fields", () => this.getInitialCustomFields())
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
  },

  destroyed() {
    bus.$off("reload-custom-fields");
    bus.$off("toggle-create-edit-flag");
  },

  computed: {
  },

  watch: {
  },

  methods: {
    ...mapActions(["fetchStockMaterialsListObject", "getHistory", "DELETE_USER_BY_ID", "downloadAll", "importMaterialFamilies", "fetchAvailableUsers", "fetchCustomFields", "fetchCustomFields", "deleteCustomFieldByUuid"]),

    /**
     * Gets the custom fields and assigns them to the variable customFields
     */
    async getCustomFields() {
      this.loading = true;
      try {
        this.customField = await this.fetchCustomFields();
        this.customField.forEach((element) => { const newData = this.getObjectData(element); element.object_type_name = newData})
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    getObjectData(customField) {
      let objectTypeName = this.getObjectTypeName(
        customField.object_type,
        customField.table
      );
      let family = customField.object_type
        ? " (" + this.$i18n.tc("Family", 2) + ")"
        : " (" + this.$i18n.tc("Form", 2) + ")";
      return objectTypeName + family;
    },

    async deleteField() {
      try {
        this.loadingDelete = true;
        if (this.userHasPermissionTo("destroy")) {
          await this.deleteCustomFieldByUuid({id: this.itemToDelete.id, ignoreEntry: 'false'});
        }
      } catch (error) {
        if (error.response.status === 403) {
          this.confirmDeleteDialog = true;
          return;
        }
        console.error(error);
        this.$toasted.global.toast_error(error.response.data.data);
      } finally {
        this.resetValues();
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    async handleMainAction() {
      this.loadingUpload = true;

      try {

        let formData = new FormData();

        formData.append("file", this.file);
        formData.append("file_type", "xlsx");

        // Make the HTTP request to upload the file
        await this.importMaterialFamilies(formData);

        this.$toasted.global.toast_success(this.$i18n.t("FileUploadedSuccessfully"));
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(this.$i18n.t("FileUploadError"));
      } finally {
        this.loadingUpload = false;
        bus.$emit("clear-drop-button-file")
        this.closeDialog();
        this.getInitialUsers();
      }
    },

    handleSecondaryAction() {
      bus.$emit("clear-drop-button-file")
      this.closeDialog();
      setTimeout(() => {
        this.activeTabDialog = 0;
      }, 1000);
    },
    handleExtraAction() {
      this.handleDownload();
    },

    updateFile(e) {
      this.file = e
    },

    async getInitialCustomFields() {
      this.loading = true;
      this.currentPageBot = 1
      this.currentPageTop = 1
      let queryParams = {
        "page[number]": 1,
        paginate: 25,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }
      try {
        const customFieldObject = await this.fetchCustomFields(queryParams);
        this.customField = customFieldObject.data;
        this.customField.forEach((element) => { const newData = this.getObjectData(element); element.object_type_name = newData})
        this.lastPage = customFieldObject.meta.last_page;
      } catch (error) {
        console.error(error);
      } finally{
        this.loading = false;
      }
    },

    async getCustomFieldsBottom() {
      this.loading = true;
      this.pagination = 25;
      if (this.customField.length >= 75) {
        this.currentPageTop++;
      }
      this.currentPageBot++;

      let queryParams = {
        "page[number]": this.currentPageBot,
        paginate: this.pagination,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }
      const customFieldObject = await this.fetchCustomFields(queryParams);
      this.lastPage = customFieldObject.meta.last_page;
      const allCustomField = [...this.customField, ...customFieldObject.data];
      this.customField = Array.from(new Set(allCustomField.map(a => a.id)))
        .map(id => { return allCustomField.find(a => a.id === id) })
      if (this.customField.length > 75) {
        this.customField = this.customField.slice(this.customField.length - 75);
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 2; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll - offset,
            behavior: "smooth",
          });
        }
      }
    },

    async getCustomFieldsTop() {
      this.loading = true;
      this.pagination = 25;
      this.currentPageTop--;

      let queryParams = {
        "page[number]": this.currentPageTop,
        paginate: this.pagination,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const customFieldObject = await this.fetchCustomFields(queryParams);
      this.lastPage = customFieldObject.meta.last_page;
      const allcustomField = [...customFieldObject.data, ...this.customField];
      this.customField = Array.from(new Set(allcustomField.map(a => a.id)))
      .map(id => { return allcustomField.find(a => a.id === id) })
      if (this.customField.length > 75) {
        this.customField.splice(-(this.customField.length - 75));
        this.currentPageBot--;
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 25; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll + offset,
            behavior: "smooth",
          });
        }
      }
    },


    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.customField = [];
      this.getInitialCustomFields();
    }, 1000),

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        this.getCustomFieldsBottom();
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.getCustomFieldsTop();
      }
    },

    onSortClick(sortOrder, index) {
      this.customField = []
      if (sortOrder === "asc") {
        this.sortOrder = this.headers[index].varName;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${this.headers[index].varName}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialCustomFields();
    },

    async handleDeleteForced() {
      try {
        await this.deleteCustomFieldByUuid({id: this.selectedCustomField.id, ignoreEntry: 'true'});
        bus.$emit("clear-SelectedItems")
        bus.$emit("clear-selected-row")
        this.$emit('clear-selected-item')
      } catch (error) {
        console.error(error);
      } finally {
        this.deleteDialogIsOpen = false;
        this.deleteDialogConfirmation = false;
        this.getInitialCustomFields();
      }
    },

    async handleDelete() {
      try {
        await this.deleteCustomFieldByUuid({id: this.selectedCustomField.id, ignoreEntry: 'false'});
        bus.$emit("clear-SelectedItems")
        bus.$emit("clear-selected-row")
        this.$emit('clear-selected-item')
      } catch (error) {
        console.error(error);
        this.deleteDialogConfirmation = true;
      } finally {
        this.deleteDialogIsOpen = false;
        this.getInitialCustomFields();
      }
    },

    async handleDownload() {
      try {
        let data = await this.downloadAll();
        window.open(data.file_url_public);
      } catch (e) {
        console.error(e);
      }
    },

    handleCloudDownload() {
      this.dialog = true;
    },

    handleAdd() {
      this.$emit('open-create-custom-field-form')
    },

  },
};
</script>

<style scoped>
.searchContainer {
  display: flex;
  align-items: center;
}

.tableDivContainer {
  height: 87%;
  margin-top: 5px;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
}

.rightSideTitleActions {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid var(--app-primary-base);
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

.span-custom {
  display: flex;
  padding: 0px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}

.table-custom {
  height: 90%;
}

.table-buttons-custom {
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/SystemSettingsManagement/CustomFields/TableView.vue